import '../../_helpers/sort-by.js'
export const listDevices = [
    {value:'DESKTOP', label:'Desktop'},
    {value:'TABLET', label:'Tablet'},
    {value:'MOBILE', label:'Mobile'},
    {value:'TV', label:'OTT & CTV'}
].sortBy('label')